import { render, staticRenderFns } from "./EducationButton.vue?vue&type=template&id=7f0ab616&scoped=true&"
import script from "./EducationButton.vue?vue&type=script&lang=js&"
export * from "./EducationButton.vue?vue&type=script&lang=js&"
import style0 from "./EducationButton.vue?vue&type=style&index=0&id=7f0ab616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ab616",
  null
  
)

export default component.exports